import * as React from 'react';
import * as styles from './Projects.css';
import { Element } from 'react-scroll';
import { Project, ProjectState } from './Project';
import * as classnames from 'classnames';

interface Props {
    projects: [ProjectState];
    scrollRef: string;
    title: string;
    blurb: string;
    color: string;
}

export class Projects extends React.Component<Props, {}> {

    render() {
        const color = styles[this.props.color];
        return (
            <Element name={this.props.scrollRef} className={classnames(styles.container, color)}>
                <div className={styles.title}>{this.props.title}</div>
                <div className={styles.blurb}>{this.props.blurb}</div>
                <div className={styles.projects}>
                    {this.props.projects.map((projectData: ProjectState) => {
                        return (
                            <Project
                                key={projectData.id}
                                data={projectData}
                            />
                        );
                    })}
                </div>
            </Element>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Projects.tsx